export default "__VITE_ASSET__DqhUWSTd__"